export default "__VITE_ASSET__e988e9e6__"